import '../styles/pages/ServiceThree.scss';
import serviceThreeBanner from '../assets/domiciliation.svg'
import serviceThreeBannerMobile from '../assets/phone/comptabilite.svg'
import bannerBG2 from '../assets/banner-bg2.svg';
import croissance from '../assets/icons/croissance.svg'
import diagnostic from '../assets/icons/diagnostique.svg'
import search from '../assets/icons/chercher.svg'
import rapport from '../assets/icons/rapport.svg'
import tableau from '../assets/icons/tableau-de-bord.svg'
import valid from '../assets/icons/valid.svg'
import keysIcon from '../assets/icons/aboutus/cles.svg';
import fuseeIcon from '../assets/icons/aboutus/fusee.svg';
import globeIcon from '../assets/icons/aboutus/globe.svg';
import chatIcon from '../assets/icons/aboutus/chat.svg';
import bouclier from '../assets/icons/bouclier.svg';
import horlge from '../assets/icons/horloge2.svg';
import tableau2 from '../assets/icons/tableau-de-bord2.svg';
import { useTranslation } from 'react-i18next';

const ServiceThree = () => {
    const { t } = useTranslation();
    return(
        <div className='main-container'>
            <div className='comp-header'>
                <h1> {t('serviceThree.header')} </h1>
            </div>
            <div className='comp-intro'>
                <ul>
                    <li> {t('serviceThree.intro.p1')} </li>
                    <li> {t('serviceThree.intro.p2')} </li>
                </ul>
                <div className='comp-intro-image'>
                    <img src={window.innerWidth > 768 ? serviceThreeBanner : serviceThreeBannerMobile} alt="Création d'entreprise" className='img-banner' />
                    <img src={bannerBG2} alt='background 2' className='background2' />
                </div> 
            </div>
            <div className='comp-services-container'>
                <h2> {t('serviceThree.services.title')} <span className='colored'>{t('serviceThree.services.colored')}</span> </h2>
                <div className='comp-services'>
                    <div className='comp-service-card'>
                        <img src={valid} alt='Tenue et révision' />
                        <span> {t('serviceThree.services.s1')} </span>
                    </div>
                    <div className='comp-service-card'>
                        <img src={croissance} alt='Suivi de trésorerie'  />
                        <span> {t('serviceThree.services.s2')} </span>
                    </div>
                    <div className='comp-service-card'>
                        <img src={rapport} alt='declaration fiscal' />
                        <span> {t('serviceThree.services.s3')} </span>
                    </div>
                    <div className='comp-service-card'>
                        <img src={diagnostic} alt='bilan' />
                        <span> {t('serviceThree.services.s4')} </span>
                    </div>
                    <div className='comp-service-card'>
                        <img src={tableau} alt='tableau de bord' />
                        <span> {t('serviceThree.services.s5')} </span>
                    </div>
                    <div className='comp-service-card'>
                        <img src={search} alt='audit' />
                        <span> {t('serviceThree.services.s6')} </span>
                    </div>
                </div>
            </div>
            <div className="aboutus-why-us">
                <h2> {t('serviceThree.whyUs.title')} <br/><span className='colored'>{t('serviceThree.whyUs.colored')}</span> ? </h2>
                <div className='aboutus-reasons-container'>
                    <div className="reason">
                        <img src={fuseeIcon} alt="accompagnement personnalisé icon" />
                        <span>{t('serviceThree.whyUs.r1')}</span>
                    </div>
                    <div className="reason">
                        <img src={chatIcon} alt="Tarifs transparents icon" />
                        <span>{t('serviceThree.whyUs.r2')}</span>
                    </div>
                    <div className="reason">
                        <img src={globeIcon} alt="expertise icon" />
                        <span>{t('serviceThree.whyUs.r3')}</span>
                    </div>
                    <div className="reason">
                        <img src={keysIcon} alt="solution icon" />
                        <span>{t('serviceThree.whyUs.r4')}</span>
                    </div>
                </div>
            </div>
            <div className='our-values'>
                <h2> {t('serviceThree.commitments.title')} </h2>
                <div className='values'>
                    <div className='value-card'>
                        <img src={horlge} alt='security' />
                        <span> {t('serviceThree.commitments.c1')} </span>
                    </div>
                    <div className='value-card'>
                        <img src={bouclier} alt='time' />
                        <span> {t('serviceThree.commitments.c2')} </span>
                    </div>
                    <div className='value-card'>
                        <img src={tableau2} alt='administration' />
                        <span> {t('serviceThree.commitments.c3')} </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceThree;
